resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    ProgressIndicator

    A progress indicator that displays progress in a step or a percentage format.
    Provides methods to track and set progress. Updates the UI to current progress
    state.

    Arguments:
        type (optional) [string]:
            Defaults to "step". Can be set to "step" or "percent". Specifies whether the
            progress indicator should be shown in step format (eg. 1 of 3 steps) or
            percentage format (eg. 33%).
        numSteps (optional) [integer]:
            The number of total steps. Must be greater than 0.
        initialValue (optional) [integer]:
            The initial value of the progress indicator. If numSteps is specified, the
            initial value must be between 0 and the number of steps. If numSteps is not
            specified, the initial value must be between 0 to 100.

    HTML structure:
        div(data-mogo-ui="ProgressIndicator" data-mogo-ui-initial-value="20")

    Methods (see methods for  additional usage):
        setProgress(value)

        getProgress()

        render()
*/
function ProgressIndicator() {
    this.id = null;
    this.node = null;
    this.declaredClass = null;
    this.extends = [];

    this.initialValue = -1;
    this.type = "percent"; // percent || step
    this.numSteps = -1;

    this._progress = -1;
    this._progressImage = null;
    this._progressText = null;
    this._intervalTimer = null;
    this._init = false;

    this.init = function() {
        // Add class
        $(this.node).addClass("progress-indicator");

        // Parameter checks
        if (this.type != "step" && this.type != "percent") this.type = "percent";
        if (this.numSteps > 0) {
            // Steps check
            this.numSteps = parseInt(this.numSteps);
            this.initialValue = Math.max(0, this.initialValue);
            this.initialValue = Math.min(this.initialValue, this.numSteps);
        } else if (this.numSteps < 1) {
            this.numSteps = -1;

            // Percent check
            this.initialValue = Math.max(0, this.initialValue);
            this.initialValue = Math.min(100, this.initialValue);
        }
        this._progress = this.initialValue;

        // Add progress text container
        this._progressText = $("<div class='progress-indicator__progress-text strong'></div>");
        $(this._progressText).appendTo(this.node);

        // Add progress image container
        this._generateImageContainer();
    };

    this.initAllReady = function() {
        $(this.node).css("display", "block");
        this.render();
    };

    /*
        Returns the current progress.

        Returns:
            [integer]
                Returns the current step or the current percentage, depending on the type
                of progress indicator.

    */
    this.getProgress = function() {
        return this._progress;
    };

    /*
        Sets the current progress and updates the view with the new progress.

        Arguments:
            value [integer] (required):
                A valid integer denoting the new progress value. The value must be between
                0 and 100 if numSteps was not specified during the creation of this component.
                The value must be between 0 and the number of steps if numSteps was specified
                during the creation of this component.
        Returns:
            [boolean]
                true if progress is set successfully, false otherwise.
    */
    this.setProgress = function(value) {
        if (value != null) {
            if (this.numSteps != -1) {
                if (value >= 0 && value <= this.numSteps) {
                    this._progress = value;
                    this.render();
                    return true;
                }
            } else if (this.numSteps == -1) {
                if (value >= 0 && value <= 100) {
                    this._progress = value;
                    this.render();
                    return true;
                }
            }
        }
        return false;
    };

    /*
        Updates the view with the current step/percentage values. This method is automatically
        called during initialization and with any setProgress calls.
    */
    this.render = function() {
        // Update progress image
        var percent = this._progress/100;
        if (this.numSteps != -1) {
            percent = this._progress/this.numSteps;
        }
        var rotation = 180 * percent;
        var fill_rotation = rotation * 2; // The seam between the two half fix
        if (!this._init) {
            $(this._progressImage).fadeIn(500, $.proxy(function() {
                $(".mask .fill, .mask.left", this.node).css("transform", "rotate(" + rotation + "deg)");
                $(".fill.fix", this.node).css("transform", "rotate(" + fill_rotation + "deg)");
            }, this))
        } else {
            $(".mask .fill, .mask.left", this.node).css("transform", "rotate(" + rotation + "deg)");
            $(".fill.fix", this.node).css("transform", "rotate(" + fill_rotation + "deg)");
        }

        // Update progress text
        if (this.numSteps != -1 && this.type == "step") {
            $(this._progressText).fadeOut(500, $.proxy(function() {
                var currentStep = this._progress + 1;
                var text = currentStep + " of " + this.numSteps + " steps";
                if (currentStep > this.numSteps)
                    text = "You're done!";
                $(this._progressText).text(text);
                $(this._progressText).fadeIn(500);
            }, this));
        } else if (this.numSteps == -1 || this.type == "percent") {
            var convertedToPercent = this._progress;
            if (this.numSteps != -1) {
                convertedToPercent = Math.floor(this._progress / this.numSteps * 100);
            }
            var text = "";
            if (convertedToPercent == 100) {
                if (this._init)
                    text = "You're done!";
                else
                    text = "<span class='percentText'>0</span>% complete";
            } else {
                text = "<span class='percentText'>" + this._progress + "</span>% complete";
                if (!this._init)
                    text = "<span class='percentText'>0</span>% complete";

            }
            if (!this._init) {
                $(this._progressText).html(text);
                $(this._progressText).fadeIn(500, $.proxy(function() {
                    this._updatePercentage(500);
                }, this));
            } else {
                this._updatePercentage(1000);
            }
        }
        this._init = true;
    };

    this._generateImageContainer = function() {
        this._progressImage = $("<div class='progress-indicator__progress-image'></div>");
        $(this._progressImage).appendTo(this.node);
        var indicatorRoot = $("<div class='progress-image-root'></div>");
        $(indicatorRoot).appendTo(this._progressImage);
        $("<div class='circle'></div>").appendTo(indicatorRoot);
        $("<div class='mask left'></div>").appendTo($(".circle", indicatorRoot));
        $("<div class='fill'></div>").appendTo($(".mask.left", indicatorRoot));
        $("<div class='mask right'></div>").appendTo($(".circle", indicatorRoot));
        $("<div class='fill'></div>").appendTo($(".mask.right", indicatorRoot));
        // Seam gap fix
        $("<div class='fill fix'></div>").appendTo($(".mask.right", indicatorRoot)); 
        $("<div class='clear'></div>").appendTo(this.node);
    };

    this._updatePercentage = function(time) {
        var convertedToPercent = this._progress;
        if (this.numSteps != -1)
            convertedToPercent = Math.floor(this._progress / this.numSteps * 100);

        var difference = parseInt($(".percentText", this.node).text());
        difference = Math.abs(difference - convertedToPercent);
        var timeInterval = time/difference;
        if (this._intervalTimer != null) {
            clearInterval(this._intervalTimer);
            this._intervalTimer = null;
        }
        this._intervalTimer = setInterval($.proxy(this._updatePercentageRender, this), timeInterval);
    };

    this._updatePercentageRender = function() {
        var convertedToPercent = this._progress;
        if (this.numSteps != -1)
            convertedToPercent = Math.floor(this._progress / this.numSteps * 100);

        var current = parseInt($(".percentText", this.node).text()) || 0;
        if (current >= convertedToPercent)
            current--;
        else
            current++;
        if (current == 100) {
            $(".progress-indicator__progress-text", this.node).text("You're done!");
        } else {
            if ($(".percentText", this.node).length == 0) {
                $(".progress-indicator__progress-text", this.node).text("% complete");
                $("<span class='percentText'></span>").prependTo($(".progress-indicator__progress-text", this.node));
            }
            $(".percentText", this.node).text(current);
        }
        if (current == convertedToPercent) {
            clearInterval(this._intervalTimer);
            this._intervalTimer = null;
        }
    };
}